import React from 'react';
import ContainerFlex from '~/components/containerFlex';
import DocumentsTable from '~/components/DocumentsTable';

interface DocumentsSectionProps {
  dataDocuments: any[];
  dataBenefit: any[];
  onSelectOption: (value: any) => void;
  onOpenDetails: (value: boolean) => void;
}

const DocumentsSection: React.FC<DocumentsSectionProps> = ({
  dataDocuments,
  dataBenefit,
  onSelectOption,
  onOpenDetails,
}) => {
  return (
    <ContainerFlex marginLeft={26} marginRight={26}>
      <DocumentsTable
        data={dataDocuments}
        dataBenefit={dataBenefit}
        handleSelectOption={onSelectOption}
        handleOpenDetails={onOpenDetails}
      />
    </ContainerFlex>
  );
};

export default DocumentsSection;
